// See https://github.com/JohannesKlauss/react-hotkeys-hook/issues/421
const QUESTION_MARK = 'shift+?';

/**
 * NOTE: please add shortcuts to ShortcutsModal.jsx when you modify this object.
 */
export const SHORTCUTS = {
  // Fields page
  SHOW_HIDE_GROUPS: { key: 'alt+g', description: 'Show/hide section groups' },
  SHOW_HIDE_LAYERS: { key: 'alt+l', description: 'Show/hide layers' },
  SHOW_HIDE_SECTIONS: { key: 'alt+s', description: 'Show/hide sections' },
  TOGGLE_RIGHT_MENU_TABS: {
    key: 'alt+backslash',
    description: 'Toggle between tabs in the right menu',
  },
  TOGGLE_MAP_FULLSCREEN: { key: 'alt+f', description: 'Toggle map fullscreen' },

  // Fields: Section/Layer editing
  DRAW: { key: 'd', description: 'Enter draw mode' },
  EDIT: { key: 'e', description: 'Enter edit mode' },
  ROTATE: { key: 'r', description: 'Enter rotate mode' },
  OFFSET: { key: 'o', description: 'Enter offset mode' },

  // Fields: New Section
  NEW_GRID: { key: 'g', description: 'New grid section' },
  NEW_LINE: { key: 'l', description: 'New line section' },
  NEW_KEYLINE: { key: 'k', description: 'New keyline section' },

  // Layers: Select Layer or New Layer
  ROADS: { key: 'shift+r', description: 'Select/create roads layer' },
  UTILITIES: { key: 'shift+u', description: 'Select/create utilities layer' },
  HEADLANDS: { key: 'shift+h', description: 'Select/create headlands layer' },
  PIPING: { key: 'shift+p', description: 'Select/create piping layer' },
  FENCES: { key: 'shift+f', description: 'Select/create fences layer' },
  BUILDINGS: { key: 'shift+b', description: 'Select/create buildings layer' },

  // Custom layer draw modes
  CUSTOM_LAYER_DRAW_POINT: {
    key: '1',
    description: 'Change draw mode: points',
  },
  CUSTOM_LAYER_DRAW_LINE: { key: '2', description: 'Change draw mode: lines' },
  CUSTOM_LAYER_DRAW_POLYGON: {
    key: '3',
    description: 'Change draw mode: polygons',
  },

  // Measurement modes
  START_MEASUREMENT: { key: 'm', description: 'Start measurment' },
  MEASURE_DISTANCE: {
    key: '1',
    description: 'Change measurement mode: distance',
  },
  MEASURE_AREA: { key: '2', description: 'Change measurement mode: area' },

  // Econ
  TOGGLE_CHART: { key: 'c', description: 'Toggle chart' },
  TOGGLE_DESIGN_PANEL: { key: 'd', description: 'Toggle design panel' },

  // Various
  CLOSE: { key: 'esc', description: 'Close / Done / Exit' },

  // Meta
  SHOW_SHORTCUTS: { key: QUESTION_MARK, description: 'Show all shortcuts' },
};
